import { render, staticRenderFns } from "./TrainingsPriceModal.vue?vue&type=template&id=533d27ec&scoped=true"
import script from "./TrainingsPriceModal.vue?vue&type=script&lang=js"
export * from "./TrainingsPriceModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingsPriceModal.vue?vue&type=style&index=0&id=533d27ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d27ec",
  null
  
)

export default component.exports